module.exports = __webpack_public_path__ + "img/5.932f1236.jpg";